"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTableInner = exports.QuoteTable = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var qtpager_1 = require("../qtpager");
var config_1 = require("../../modules/quote/config");
var quote_1 = require("../../modules/quote");
var addzxgbtn_1 = require("../page/shared/zxg/addzxgbtn");
var tablepage_config_1 = require("./tablepage_config");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var hk_rule_tip_1 = require("../page/shared/hk_rule_tip");
var xglinks_1 = require("./xglinks");
var url_1 = require("../../modules/url");
var hk_rule_1 = __importDefault(require("../../modules/hk_rule"));
function QuoteTable(props) {
    var _this = this;
    //香港延时市场
    var _a = (0, react_1.useState)(null), hk_delay = _a[0], SetHKDelay = _a[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var hkdelay_result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hk_rule_1.default.isDelayCache()];
                    case 1:
                        hkdelay_result = _a.sent();
                        if (hkdelay_result) {
                            SetHKDelay(hkdelay_result);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    if (hk_delay == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    //包装获取港股延迟
    return react_1.default.createElement(QuoteTableInner, __assign({ hk_delayinfo: hk_delay }, props));
}
exports.QuoteTable = QuoteTable;
/**
 * 行情表格
 * @returns
 */
function QuoteTableInner(props) {
    var _a, _b;
    var mt = (_a = props.mt) !== null && _a !== void 0 ? _a : 0;
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash.toLowerCase();
    if (hash.substring(0, 1) == '#') {
        hash = hash.substring(1);
    }
    var thishash = (0, react_1.useRef)(hash);
    if (!hash && !!(props === null || props === void 0 ? void 0 : props.custom_hash)) {
        hash = props.custom_hash;
    }
    // console.info(hash)
    //配置字段
    var hashtable_item = tablepage_config_1.hashtable[hash];
    var tbkey = hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.table;
    var fs = hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.fs;
    //港股延迟fs
    if (((_b = props.hk_delayinfo) === null || _b === void 0 ? void 0 : _b.re) && (hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.hk_delayfs))
        fs = hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.hk_delayfs;
    // 单个小板块
    if (!!/^boards2\-90\.(bk|BK)\d+$/.test(hash)) {
        tbkey = 'bkchild';
        fs = "b:".concat(hash.split(".")[1], "+f:!50");
    }
    var tableitem = (0, lodash_1.cloneDeep)(tablepage_config_1.tableitemconfig[tbkey]);
    //自定义字段
    if (props.custom_item) {
        var customindex = tableitem.findIndex(function (v) { return v.type == 'custom'; });
        if (customindex > -1) {
            tableitem = tableitem.slice(0, customindex).concat([__assign({ type: 'quote' }, props.custom_item)]).concat(tableitem.slice(customindex + 1));
        }
    }
    var default_sort = getDefaultSort(tableitem); //默认排序
    // console.log(default_sort)
    // console.log(tableitem)
    var _c = (0, react_1.useState)([]), showdata = _c[0], SetShowData = _c[1];
    var _d = (0, react_1.useState)(true), initstate = _d[0], SetInitState = _d[1];
    var _e = (0, react_1.useState)(0), count = _e[0], SetCount = _e[1];
    var _f = (0, react_1.useState)(1), nowindex = _f[0], SetNowIndex = _f[1];
    var _g = (0, react_1.useState)(default_sort.sort), sortitem = _g[0], SetSortItem = _g[1]; // 排序字段
    // const [sortdirect, SetSortDirect] = useState(sort_direct) // 优先url
    var _h = (0, react_1.useState)(default_sort.sort_direct), sortdirect = _h[0], SetSortDirect = _h[1]; // 优先url
    var _j = (0, react_1.useState)(Math.random()), data_reload = _j[0], setReload = _j[1];
    var pagesize = 20;
    var getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var quotedata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, quote_1.searchListQuoteWithPage)(fs, getConfigQuoteItem(tableitem), sortitem, nowindex, pagesize, sortdirect)];
                    case 1:
                        quotedata = _a.sent();
                        SetInitState(false);
                        if (quotedata.result.length >= 0)
                            SetShowData(quotedata.result);
                        SetCount(quotedata.count);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        // if (hash != thishash.current) {
        //   console.info('change hash:' + hash)
        //   SetNowIndex(1)
        //   SetSortItem(default_sort.sort)
        //   SetSortDirect(default_sort.sort_direct)
        // }
        // thishash.current = hash
        getData();
    }, [nowindex, sortdirect, sortitem, props.custom_item, data_reload]);
    var changeNowIndex = function (toindex) {
        SetNowIndex(toindex);
        try {
            if (window['websitecaptcha_checkuser']) {
                window['websitecaptcha_checkuser']();
            }
        }
        catch (error) {
        }
    };
    (0, react_1.useEffect)(function () {
        if (hash != thishash.current) {
            // console.info('change hash:' + hash)
            changeNowIndex(1);
            SetSortItem(default_sort.sort);
            SetSortDirect(default_sort.sort_direct);
            setReload(Math.random());
        }
        thishash.current = hash;
        // getData()
    }, [hash]);
    var changeSort = function (tosortitem) {
        SetSortItem(tosortitem);
        if (sortitem == tosortitem) {
            if (sortdirect == 0) {
                SetSortDirect(1);
            }
            else {
                SetSortDirect(0);
            }
        }
        else {
            SetSortDirect(1);
        }
    };
    var refresh = function () {
        getData();
    };
    return (react_1.default.createElement("div", { className: "quotetable", style: mt > 0 ? { marginTop: mt } : {} },
        react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, tableitem.filter(function (v) { return v.hide != true; }).map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, className: v.sort ? 'sort' : '', title: v.sort ? '点击排序' : '', onClick: function () { if (v.sort) {
                            changeSort(config_1.ListItemConfig === null || config_1.ListItemConfig === void 0 ? void 0 : config_1.ListItemConfig[config_1.QuoteItem[v.value]].sort);
                        } } },
                        v.type != 'sort_change' && v.title,
                        v.type == 'sort_change' &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                sortdirect == 1 && react_1.default.createElement("span", null, v.desc.title),
                                sortdirect == 0 && react_1.default.createElement("span", null, v.esc.title)),
                        v.sort && (config_1.ListItemConfig === null || config_1.ListItemConfig === void 0 ? void 0 : config_1.ListItemConfig[config_1.QuoteItem[v.value]].sort) == sortitem && sortdirect == 1 &&
                            react_1.default.createElement("span", { className: "icon_down" }),
                        v.sort && (config_1.ListItemConfig === null || config_1.ListItemConfig === void 0 ? void 0 : config_1.ListItemConfig[config_1.QuoteItem[v.value]].sort) == sortitem && sortdirect == 0 &&
                            react_1.default.createElement("span", { className: "icon_up" }));
                }))),
            react_1.default.createElement("tbody", null, showdata.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitem.filter(function (v) { return v.hide != true; }).map(function (v2, index2) {
                    return react_1.default.createElement("td", { key: index2, className: v2.tdclass ? v2.tdclass : '' },
                        v2.type == 'index' && ((nowindex - 1) * pagesize + index + 1),
                        v2.type == 'quote' && v[config_1.QuoteItem[v2.value]] && v[config_1.QuoteItem[v2.value]].html,
                        v2.type == 'sort_change' &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                sortdirect == 1 && v[config_1.QuoteItem[v2.desc.value]].html,
                                sortdirect == 0 && v[config_1.QuoteItem[v2.esc.value]].html),
                        v2.type == 'astock_xg_link' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinkAStock, { code: v[config_1.QuoteItem.代码带链接].txt }),
                        v2.type == 'zx_link' && v[config_1.QuoteItem.名称] &&
                            react_1.default.createElement(xglinks_1.XGLinkZX, { name: v[config_1.QuoteItem.名称].txt }),
                        v2.type == 'gb_zx_link' && v[config_1.QuoteItem.代码带链接] && v[config_1.QuoteItem.名称] &&
                            react_1.default.createElement(xglinks_1.XGLinkGBZX, { code: v[config_1.QuoteItem.代码带链接].txt, name: v[config_1.QuoteItem.名称].txt }),
                        v2.type == 'jj_etf_link' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinkJJ, { code: v[config_1.QuoteItem.代码带链接].txt }),
                        v2.type == 'gb_hka_link' && v[config_1.QuoteItem.H股对应的A股代码] &&
                            react_1.default.createElement(xglinks_1.AHXGLinkGB, { code: v[config_1.QuoteItem.H股对应的A股代码].txt }),
                        v2.type == 'gb_hk_link' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinkGBHK, { code: v[config_1.QuoteItem.代码带链接].txt }),
                        v2.type == 'gb_zj_yb_link' && v[config_1.QuoteItem.代码带链接] &&
                            react_1.default.createElement(xglinks_1.XGLinks, { quotecode: v[config_1.QuoteItem.代码带链接].txt, xgtype: "bk_hy" }),
                        v2.type == 'hk_xg_link' && v[config_1.QuoteItem.代码带链接] && v[config_1.QuoteItem.名称] && v[config_1.QuoteItem.证券类型] &&
                            react_1.default.createElement(xglinks_1.XGLinksHK, { code: v[config_1.QuoteItem.代码带链接].txt, name: v[config_1.QuoteItem.名称].txt, type: v[config_1.QuoteItem.证券类型].txt }),
                        v2.type == 'add_zxg' &&
                            react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v[config_1.QuoteItem.行情统一链接].source }));
                }));
            }))),
        (showdata.length == 0 && !initstate) &&
            react_1.default.createElement("div", { style: { textAlign: "center", padding: "30px 0" } }, "\u6682\u65E0\u76F8\u5173\u6570\u636E"),
        props.hk_delayinfo.re && (hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.show_hk_delay_info) == true && react_1.default.createElement(hk_rule_tip_1.HKDelayRoleTip, { tiptxt: props.hk_delayinfo.message, mt: 5 }),
        count > 0 &&
            react_1.default.createElement(qtpager_1.QTPager, { count: count, pagesize: pagesize, nowindex: nowindex, onChangePager: function (toindex) { changeNowIndex(toindex); } })));
}
exports.QuoteTableInner = QuoteTableInner;
/**
 * 获取默认的排序设置 兼容url参数处理
 * @param config
 * @returns
 */
function getDefaultSort(config) {
    var url_sort_direct = (0, url_1.getQueryParams)("amp;sr") || (0, url_1.getQueryParams)("sr"); // 排序方向 &amp;转义符
    var url_sort_item = (0, url_1.getQueryParams)("st"); // 排序字段
    var finddefault;
    // 取url配置
    if (url_sort_item != null) {
        finddefault = config.find(function (v) { var _a; return ((_a = v.sort_alias) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == url_sort_item.toLowerCase(); });
    }
    // 取默认配置
    if (url_sort_item == null && finddefault == undefined) {
        finddefault = config.find(function (v) { return v.sort_default; });
    }
    // let url_dir = url_sort_direct == -1 ? 1 : url_sort_direct  //兼容老的定义
    var url_dir = url_sort_direct == -1 ? 1 : url_sort_direct == 1 ? 0 : url_sort_direct;
    // console.log(url_dir)
    if (finddefault) {
        return {
            sort: config_1.ListItemConfig[config_1.QuoteItem[finddefault.value]].sort,
            sort_direct: url_dir != null ? url_dir : finddefault.sort_direct // url 优先  0 升 1降
        };
    }
    return {
        sort: '',
        sort_direct: 1
    };
}
/**
 * 获取自定义表格的所有行情字段
 * @param tableitem
 */
function getConfigQuoteItem(tableitem) {
    var back1 = tableitem.filter(function (v) { return v.type == 'quote'; }).map(function (v) { return config_1.QuoteItem[v.value]; });
    var back2 = tableitem.filter(function (v) { return v.type == 'sort_change'; }).map(function (v) { return [config_1.QuoteItem[v.desc.value], config_1.QuoteItem[v.esc.value]]; });
    back2.forEach(function (back2item) {
        back1.push(back2item[0], back2item[1]);
    });
    return back1;
}
